<template>
  <TableLayout>
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="优惠券名称" prop="couponName">
        <el-input v-model="searchForm.couponName" placeholder="请输入优惠券名称" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="searchForm.status" placeholder="请选择状态" clearable @change="search">
          <el-option label="待核销" :value="0"></el-option>
          <el-option label="已过期" :value="1"></el-option>
          <el-option label="已核销" :value="2"></el-option>
          <el-option label="待支付" :value="3"></el-option>
          <el-option label="待领取" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="领取方式" prop="acquireMethod">
        <el-select v-model="searchForm.acquireMethod" placeholder="请选择领取方式" clearable @change="search">
          <el-option label="免费领取" value="FREE"></el-option>
          <el-option label="付费购" value="PURCHASE"></el-option>
          <el-option label="积分兑换" value="POINTS"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号" prop="userId">
        <el-select
          v-model="searchForm.userId"
          placeholder="请选择手机号"
          filterable
          remote
          :remote-method="getUserList"
          :loading="userListLoading"
          clearable
          style="width: 200px;"
        >
          <el-option
            v-for="user in userList"
            :key="user.id"
            :label="user.mobile"
            :value="user.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button type="primary" @click="$refs.operaCouponListWindow.open('新建')" icon="el-icon-plus">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete">删除</el-button></li>
        <li><el-button @click="openWriteOff">核销优惠券</el-button></li>
      </ul>
      <el-dialog title="核销优惠券" :visible.sync="dialogFormVisible" width="30%" :before-close="closeDialog">
      <el-form :model="writeoffForm">
        <el-form-item label="优惠券编号">
          <el-input v-model="writeoffForm.code" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="useCouponCode" :loading="useCouponLoading">核销</el-button>

      </div>
      </el-dialog>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="" min-width="100px"></el-table-column>
        <el-table-column prop="couponName" label="优惠券名称" min-width="100px"></el-table-column>
        <el-table-column prop="couponCode" label="优惠券编号" min-width="100px"></el-table-column>
        <el-table-column prop="createTime" label="登录时间" min-width="140px" sortable="custom" sort-by="CREATE_TIME"></el-table-column>
        <el-table-column prop="userInfo.mobile" label="手机号" min-width="100px"></el-table-column>
        <el-table-column prop="startTime" label="发放时间" min-width="100px"></el-table-column>
        <el-table-column prop="endTime" label="截止时间" min-width="100px"></el-table-column>
        <el-table-column prop="acquireMethod" label="领取方式" min-width="100px">
          <template slot-scope="{row}">
            {{ getAcquireMethodText(row.acquireMethod) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" min-width="100px">
          <template slot-scope="{row}">
            <el-tag :type="getPayStatusType(row.status)" size="small">
              {{ getPayStatusText(row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="usedTime" label="核销时间" min-width="100px"></el-table-column>
        <el-table-column
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaCouponListWindow.open('编辑', row)" icon="el-icon-edit">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaCouponListWindow ref="operaCouponListWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaCouponListWindow from '@/components/rentHouse/OperaCouponListWindow'
import { fetchList } from '../../api/system/user'
import { useCoupon } from '../../api/rentHouse/couponList'

export default {
  name: 'CouponList',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaCouponListWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        couponCode: null,
        couponName: null,
        delFlag: null,
        endTime: null,
        startTime: null,
        status: null,
        usedTime: null,
        templateId: null,
        userId: null,
        acquireMethod: null
      },
      // 核销优惠券
      writeoffForm: {
        code: ''
      },
      tagLoading: false,
      dialogFormVisible: false,
      userList: [],
      userListLoading: false,
      useCouponLoading: false
    }
  },
  created () {
    this.config({
      module: '',
      api: '/rentHouse/couponList',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
    this.getUserList()
  },
  methods: {
    openWriteOff () {
      this.dialogFormVisible = true
    },
    getPayStatusText (status) {
      const statusMap = {
        0: '待核销',
        1: '已过期',
        2: '已核销',
        3: '待支付',
        4: '待领取'
      }
      return statusMap[status]
    },
    // 获取支付状态标签类型
    getPayStatusType (status) {
      const typeMap = {
        0: 'warning',
        1: 'info',
        2: 'danger',
        3: 'primary',
        4: 'info'
      }
      return typeMap[status]
    },
    getAcquireMethodText (method) {
      const map = {
        FREE: '免费领取',
        PURCHASE: '付费购',
        POINTS: '积分兑换'
      }
      return map[method] || method || '-'
    },
    // 获取用户列表
    async getUserList (mobile) {
      this.userListLoading = true
      const res = await fetchList({
        page: 1,
        capacity: 50,
        model: {
          mobile: mobile
        }

      })
      this.userList = res.records
      console.log(this.userList)
      this.userListLoading = false
    },

    async useCouponCode () {
      this.$confirm('确定核销优惠券吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.useCouponLoading = true
        const res = await useCoupon(this.writeoffForm.code)
        if (res) {
          this.$message({
            message: '核销成功',
            type: 'success'
          })
          this.$nextTick(() => {
            this.dialogFormVisible = false
            this.useCouponLoading = false
            this.search()
          })
        } else {
          this.$message({
            message: '核销失败',
            type: 'error'
          })
          this.$nextTick(() => {
            this.writeoffForm.code = ''
            this.dialogFormVisible = false
            this.useCouponLoading = false
          })
        }
      })
    },
    closeDialog () {
      this.writeoffForm.code = ''
      this.dialogFormVisible = false
    }
  }
}
</script>
<style scoped>
  .el-select-dropdown__item{
    height: auto !important;
  }
</style>
